import { HttpEventType } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { finalize, map, Subscription, tap } from 'rxjs';
import { ModalMessageComponent, ModalMessageType } from 'src/app/component/controls/modal-message/modal-message.component';
import { ModalConfig } from 'src/app/component/controls/modal/modal-config';
import { ModalRef } from 'src/app/component/controls/modal/modal-ref';
import { Modal } from 'src/app/component/controls/modal/modal.service';
import { FileSizePipe } from 'src/app/pipe/file-size.pipe';
import { SupportService } from 'src/app/service/support.service';

export class UploadFileStatus {
    fileName: string;
    status: string;
    percentage: string | number;
    uploadedBytes: number;
    totalBytes: number;
}

export enum SFTPUploadResult {
  UPLOADED,
  FAILED,
  CANCELED
}

@Component({
  selector: 'app-supportcase',
  templateUrl: './supportcase.component.html',
  styleUrl: './supportcase.component.css',
  standalone: false
})
export class SupportcaseComponent implements OnInit{
  width:string;
  text:string;
  item:UploadFileStatus = new UploadFileStatus();
  uploading: boolean = true;
  logsPkgId:string = "";
  path:string = "";
  errorMsg:string = "";
  title:string = $localize`Uploading Log Packages...`;
  uploadStatus:SFTPUploadResult;
  cancelModelRef: ModalRef;

  constructor(private modalRef: ModalRef, public modalConfig: ModalConfig, 
              public supportSevice:SupportService, protected modal: Modal) { 
    this.logsPkgId = this.modalConfig.data.logsPkgId;
    this.item.fileName = this.modalConfig.data.logsPkgName;
    this.path = this.modalConfig.data.path;
  }

  ngOnInit() {
    this.text = $localize`Connecting...`;
    this.item.percentage = 0;
    this.item.status = "UPLOADING";
    this.item.uploadedBytes = 0;

    this.supportSevice.uploadToSFTP(this.path, this.logsPkgId)
          .pipe(
            map(event => {
              let lastSeenBytes:number = 0;
              switch (event.type) {
                case HttpEventType.Sent:
                  this.text = $localize`Uploading ${this.item.fileName}. This may take a moment.`;
                  break;
                case HttpEventType.DownloadProgress:
                  const newData = event.partialText.substring(lastSeenBytes);
                  lastSeenBytes = event.partialText.length;
                  const events:string[] = newData.split('\n\n');
                  events.forEach(event => {
                    if(event.startsWith('data: ')) {
                      const data = event.substring(6);
                      let progress = JSON.parse(data);
                      
                      if(!progress.success){
                        this.uploadStatus = SFTPUploadResult.FAILED;
                        this.close();
                      }else{
                        this.item.percentage = progress.progress;
                        this.item.uploadedBytes = progress.uploadedBytes;
                        this.item.totalBytes = progress.totalBytes;
                        this.text = $localize`Uploading ${new FileSizePipe().transform(this.item.uploadedBytes)} of ${new FileSizePipe().transform(this.item.totalBytes)}`
                        if(this.item.percentage == 100){
                          if(this.cancelModelRef){
                            this.cancelModelRef.close();
                          }
                          this.uploading = false;
                          this.uploadStatus = SFTPUploadResult.UPLOADED;
                          this.title = $localize`Upload complete.`;
                          this.text = $localize`Successfully uploaded ${this.item.fileName}.`;
                        }
                      }
                    }
                  });
                  break;
              }
            }),
            finalize(() => {
              this.uploading = false;
            })
          ).subscribe();
  }

  close():void {
    this.modalRef.close(this.uploadStatus);
  }

  cancel(): void {
    this.cancelModelRef = this.modal.open(ModalMessageComponent, {
            data: {
              title: $localize`Cancel Upload Confirmation`,
              message:  $localize`Are you sure you want to cancel uploading the log package?`,
              type: ModalMessageType.Question,
              primaryBtn: $localize`Yes`,
              secondaryBtn: $localize`No`,
              width: '475px'
            },
            id: 'otsc-log-package-exit-confirm-dlg'
          }
          );
    const sub: Subscription = this.cancelModelRef
          .afterClosed.subscribe((result: boolean) => {
            if (result) {
              this.uploadStatus = SFTPUploadResult.CANCELED;
              this.supportSevice.cancelUploadingToSFTP(this.path, this.logsPkgId).pipe(
                tap(() => {
                  this.modalRef.close(this.uploadStatus);
                })
              ).subscribe();
            }
            sub.unsubscribe();
          });
  }
}
